
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qrxS", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $7dyLS = parcelRequire("7dyLS");

var $1C4cT = parcelRequire("1C4cT");


var $icARO = parcelRequire("icARO");


var $3FTlm = parcelRequire("3FTlm");


var $d4Mwr = parcelRequire("d4Mwr");

const $a7827c25df0a1c01$var$messages = (0, $aXWIB.defineMessages)({
    create: {
        id: "link-create.jira-plugin-create-config",
        defaultMessage: "Create"
    }
});
const $a7827c25df0a1c01$export$c0007b48d375a9ff = {
    tabConfig: {
        tabKey: 'jira',
        tabTitle: 'Jira'
    },
    products: [
        'jira'
    ],
    scope: (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter
};
const $a7827c25df0a1c01$export$af1b31f68dc05ab3 = (formatMessage)=>({
        ...$a7827c25df0a1c01$export$c0007b48d375a9ff,
        action: {
            label: formatMessage($a7827c25df0a1c01$var$messages.create),
            callback: ()=>{
                console.log('Placeholder for Jira Create');
            }
        }
    });
const $a7827c25df0a1c01$export$3fc43c5f39c4a529 = {
    tabConfig: {
        tabKey: 'confluence',
        tabTitle: 'Confluence'
    },
    products: [
        'confluence'
    ],
    scope: (0, $7dyLS.Scope).ConfluenceContentType
};
const $a7827c25df0a1c01$export$547f1973f56da40b = {
    tabConfig: {
        tabKey: 'atlas',
        tabTitle: 'Atlas'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$32f102fef46346 = {
    tabConfig: {
        tabKey: 'home',
        tabTitle: 'Home'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$b1b5e4959b6adcf2 = {
    tabConfig: {
        tabKey: 'loom',
        tabTitle: 'Loom'
    },
    products: [
        'loom'
    ],
    scope: (0, $7dyLS.Scope).Loom,
    disableActivityClient: true
};
const $a7827c25df0a1c01$var$currentProductToPluginMap = {
    jira: $a7827c25df0a1c01$export$c0007b48d375a9ff,
    confluence: $a7827c25df0a1c01$export$3fc43c5f39c4a529,
    atlas: $a7827c25df0a1c01$export$547f1973f56da40b,
    loom: $a7827c25df0a1c01$export$b1b5e4959b6adcf2,
    townsquare: $a7827c25df0a1c01$export$32f102fef46346
};
const $a7827c25df0a1c01$export$ede9abe489c9321b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $frIzR.c)(33);
    let t0;
    if ($[0] !== config) {
        t0 = config ?? {};
        $[0] = config;
        $[1] = t0;
    } else t0 = $[1];
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = t0;
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $d4Mwr.useAvailableProducts)(config?.cloudId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[2] !== config?.product) {
        t1 = config?.product?.toLowerCase();
        $[2] = config?.product;
        $[3] = t1;
    } else t1 = $[3];
    const currentProduct = t1;
    let t2;
    if ($[4] !== activityClientEndpoint || $[5] !== aggregatorUrl || $[6] !== cloudId) {
        t2 = (config_0)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config_0
            });
        $[4] = activityClientEndpoint;
        $[5] = aggregatorUrl;
        $[6] = cloudId;
        $[7] = t2;
    } else t2 = $[7];
    const createPluginConfig = t2;
    let t3;
    if ($[8] !== createPluginConfig || $[9] !== formatMessage) {
        t3 = createPluginConfig((0, $dh538.fg)("platform.linking-platform.link-picker.enable-jira-create") ? $a7827c25df0a1c01$export$af1b31f68dc05ab3(formatMessage) : $a7827c25df0a1c01$var$currentProductToPluginMap.jira);
        $[8] = createPluginConfig;
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[11] !== createPluginConfig) {
        t4 = createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.confluence);
        t5 = createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.atlas);
        t6 = createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.townsquare);
        t7 = createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.loom);
        $[11] = createPluginConfig;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else {
        t4 = $[12];
        t5 = $[13];
        t6 = $[14];
        t7 = $[15];
    }
    let t8;
    if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
        t8 = {
            jira: t3,
            confluence: t4,
            atlas: t5,
            townsquare: t6,
            loom: t7
        };
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    const configMap = t8;
    let t9;
    if ($[22] !== availableProducts || $[23] !== configMap || $[24] !== currentProduct || $[25] !== isLoading) {
        const plugins = [];
        const isLoomBetaEnabled = (0, $c6GJD.default).checkGate("confluence_loom_beta_enabled");
        const isLoomM25Enabled = (0, $c6GJD.default).checkGate("confluence_frontend_loom_cross_sell");
        if (currentProduct && (0, $3FTlm.isSupportedCurrentProduct)(currentProduct)) plugins.push(configMap[currentProduct]);
        let t10;
        if ($[27] !== currentProduct) {
            t10 = (product)=>currentProduct !== product;
            $[27] = currentProduct;
            $[28] = t10;
        } else t10 = $[28];
        let t11;
        if ($[29] !== currentProduct) {
            t11 = (product_0)=>{
                if (currentProduct === "townsquare") return product_0 !== "atlas";
                return !!product_0;
            };
            $[29] = currentProduct;
            $[30] = t11;
        } else t11 = $[30];
        let t12;
        if ($[31] !== configMap) {
            t12 = (product_2)=>configMap[product_2];
            $[31] = configMap;
            $[32] = t12;
        } else t12 = $[32];
        t9 = {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $icARO.supportedCurrentProducts).filter(t10).filter(t11).filter((product_1)=>product_1 === "loom" && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product_1 === (0, $3FTlm.lookupCurrentProductByProduct)(availableProduct) && (product_1 !== "loom" || isLoomM25Enabled))).map(t12)
            ]
        };
        $[22] = availableProducts;
        $[23] = configMap;
        $[24] = currentProduct;
        $[25] = isLoading;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : (config)=>{
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = config ?? {};
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $d4Mwr.useAvailableProducts)(config?.cloudId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    /**
   * Lower case possible name of product. Should be `confluence` or `jira`.
   * This typing is not ideal. An unknown current product will:
   * - in the case of no 1P tabs enabled, default to Scope.ConfluencePageBlog scope
   * - in the case of 1P tabs enabled, not ensure the first tab is the current product
   */ const currentProduct = config?.product?.toLowerCase();
    const createPluginConfig = (0, $42omo.useMemo)(()=>{
        return (config_0)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config_0
            });
    }, [
        cloudId,
        activityClientEndpoint,
        aggregatorUrl
    ]);
    const configMap = (0, $42omo.useMemo)(()=>{
        return {
            jira: createPluginConfig((0, $dh538.fg)('platform.linking-platform.link-picker.enable-jira-create') ? $a7827c25df0a1c01$export$af1b31f68dc05ab3(formatMessage) : $a7827c25df0a1c01$var$currentProductToPluginMap.jira),
            confluence: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.confluence),
            atlas: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.atlas),
            townsquare: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.townsquare),
            loom: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.loom)
        };
    }, [
        createPluginConfig,
        formatMessage
    ]);
    return (0, $42omo.useMemo)(()=>{
        const plugins = [];
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomBetaEnabled = (0, $c6GJD.default).checkGate('confluence_loom_beta_enabled');
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomM25Enabled = (0, $c6GJD.default).checkGate('confluence_frontend_loom_cross_sell');
        // Add plugin for current product as the first tab, if we have a supported tab for it
        // We are assuming that if a product is the current product and we have a supported tab, it's in available products
        // (eg. we assume if you're in Jira, Jira will be in available products)
        if (currentProduct && (0, $3FTlm.isSupportedCurrentProduct)(currentProduct)) plugins.push(configMap[currentProduct]);
        return {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $icARO.supportedCurrentProducts)// Exclude the current product, we've already included it above if theres a matching config available
                .filter((product)=>currentProduct !== product)// Exclude 'Atlas' tab is there is already a 'Home' tab
                .filter((product_0)=>{
                    if (currentProduct === 'townsquare') return product_0 !== 'atlas';
                    return !!product_0;
                })// Remove any products that did not appear in the list of availableProducts
                // Does not factor in the currentProduct, that will still be in the resulting array as it
                // has been included seperately above
                .filter((product_1)=>product_1 === 'loom' && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product_1 === (0, $3FTlm.lookupCurrentProductByProduct)(availableProduct) && (product_1 !== 'loom' || isLoomM25Enabled)))// Map product strings to their defined config in the config map
                .map((product_2)=>configMap[product_2])
            ]
        };
    }, [
        configMap,
        availableProducts,
        currentProduct,
        isLoading
    ]);
};
const $a7827c25df0a1c01$export$45a18a62e79260ff = (0, $4pOgL.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $frIzR.c)(3);
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $a7827c25df0a1c01$export$ede9abe489c9321b(config);
    const plugins = (0, $1C4cT.useAtlassianPlugins)(atlassianPluginsConfig);
    let t0;
    if ($[0] !== isLoading || $[1] !== plugins) {
        t0 = {
            plugins: plugins,
            isLoading: isLoading
        };
        $[0] = isLoading;
        $[1] = plugins;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (config)=>{
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $a7827c25df0a1c01$export$ede9abe489c9321b(config);
    const plugins = (0, $1C4cT.useAtlassianPlugins)(atlassianPluginsConfig);
    return {
        plugins: plugins,
        isLoading: isLoading
    };
};
module.exports["useLinkPickerPlugins"] = $a7827c25df0a1c01$export$45a18a62e79260ff;

});

parcelRegister("1C4cT", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8fW0f = parcelRequire("8fW0f");

const $1ff157185fb6e44c$export$679584c8d36ab911 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (configs)=>{
    const $ = (0, $frIzR.c)(5);
    const [atlassianPlugins] = (0, $42omo.useState)($1ff157185fb6e44c$var$_temp);
    let t0;
    if ($[0] !== atlassianPlugins || $[1] !== configs) {
        let t1;
        if ($[3] !== atlassianPlugins) {
            t1 = (config)=>{
                const existingPlugin = atlassianPlugins.get(config);
                if (existingPlugin) return existingPlugin;
                const newPlugin = new (0, $8fW0f.default)(config);
                atlassianPlugins.set(config, newPlugin);
                return newPlugin;
            };
            $[3] = atlassianPlugins;
            $[4] = t1;
        } else t1 = $[4];
        t0 = configs.map(t1);
        $[0] = atlassianPlugins;
        $[1] = configs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (configs)=>{
    const [atlassianPlugins] = (0, $42omo.useState)(()=>new WeakMap());
    return (0, $42omo.useMemo)(()=>configs.map((config)=>{
            const existingPlugin = atlassianPlugins.get(config);
            if (existingPlugin) return existingPlugin;
            // If we haven't already created a plugin for this config, create one now
            // and store it in the map.
            const newPlugin = new (0, $8fW0f.default)(config);
            atlassianPlugins.set(config, newPlugin);
            return newPlugin;
        }), [
        atlassianPlugins,
        configs
    ]);
};
function $1ff157185fb6e44c$var$_temp() {
    return new WeakMap();
}
module.exports["useAtlassianPlugins"] = $1ff157185fb6e44c$export$679584c8d36ab911;

});

parcelRegister("8fW0f", function(module, exports) {

var $4CPyF = parcelRequire("4CPyF");

var $aQaGv = parcelRequire("aQaGv");


var $dh538 = parcelRequire("dh538");


var $6hu6G = parcelRequire("6hu6G");


var $7dyLS = parcelRequire("7dyLS");


var $44rik = parcelRequire("44rik");


var $k1Kn6 = parcelRequire("k1Kn6");


var $4LCen = parcelRequire("4LCen");


var $7OCSv = parcelRequire("7OCSv");


var $1MqUK = parcelRequire("1MqUK");

const $072a50f740811d00$export$452f1062ecf44be7 = 5;
const $072a50f740811d00$var$DEBOUNCE_MS = 400;
/**
 * Plugin responsible for handling fetching + caching of Atlassian Link Picker results
 */ class $072a50f740811d00$var$AtlassianLinkPickerPlugin {
    /**
   * Create search provider if config params are provided
   */ createSearchProvider(scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri) {
        if (!this.cloudId || !scope) return undefined;
        return Promise.resolve(new (0, $4LCen.default)(this.cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri, this.cloudIds));
    }
    /**
   * Filter out fields from recent or search items.
   * @param items The recent items to remove fields from.
   * @returns Items with fields removed.
   */ filterListItemFields(items) {
        // Assume this.products won't change during function call
        const products = this.products;
        // We can't filter out items if we don't have a product or we have more than one product,
        // as we can't tell which product a given item is from.
        if (products?.length !== 1) return items;
        // Config of map of products to fields to filter out from each item
        const productFieldsMap = {
            townsquare: [
                'lastViewedDate',
                'lastUpdatedDate',
                'container'
            ]
        };
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            // Set fields to be undefined when they have been specified to be based on a given product in productFieldsMap
            for (const [productToCheck, fieldsToCheck] of Object.entries(productFieldsMap)){
                if (products[0] === productToCheck) for (const field of fieldsToCheck)newItem[field] = undefined;
            }
            return newItem;
        });
    }
    /**
   * Set lastUpdatedDate for Loom search results and unset lastViewedDate.
   * @param items The recent Loom items .
   * @returns Items with lastUpdatedDate set.
   */ setLoomRecentItemsDateField(items) {
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            newItem.lastViewedDate = item.lastUpdatedDate;
            newItem.lastUpdatedDate = undefined;
            return newItem;
        });
    }
    /**
   * Retrieve recent items from the activity provider
   */ async getRecentItems() {
        if (!this.activityClient) return [];
        if (!this.recentItems) {
            const { viewed: items } = await this.activityClient.fetchActivities([
                50,
                125,
                250
            ], // retries
            {
                limit: 100,
                products: this.products,
                rootContainerIds: this.allowMultiSiteRecents ? this.cloudIds?.reduce((acc, cloudId)=>acc.concat(...(0, $1MqUK.getArisForProducts)(this.products, cloudId)), []) : // If cloudIds array is provided, do not scope activities query
                this.cloudId !== undefined && !this.isMultisiteSearch ? (0, $1MqUK.getArisForProducts)(this.products, this.cloudId) : undefined
            }, [
                'viewed'
            ], true);
            this.recentItems = items.map((0, $1MqUK.mapActivityClientResultToLinkSearchItemData));
            this.recentItems = this.filterListItemFields(this.recentItems);
        }
        return this.recentItems;
    }
    /**
   * Given a query, search the activity provider for recent activity
   */ async searchRecentItems({ query: query }) {
        if (!this.recentItems) await this.getRecentItems();
        return (0, $44rik.filterItems)(this.recentItems, query);
    }
    async quickSearch(state) {
        const isLoomRecentSearch = this._scope === (0, $7dyLS.Scope).Loom && state.query.length === 0;
        // similar to getRecentItems() we return the initial recent result when query string is reset
        if (isLoomRecentSearch && this._loomRecentItems) return this._loomRecentItems;
        const items = await this.debouncedSearch(state.query);
        let searchListItems = items.map((0, $k1Kn6.mapSearchProviderResultToLinkSearchItemData));
        // For Loom both recent and search results are fetched from search client. When search query is empty
        // the search returns recent items, when the query is not empty it returns searched items.
        // The setLoomRecentItemsDateField method sets the correct date field for the UI to consume.
        if (isLoomRecentSearch) {
            searchListItems = this.setLoomRecentItemsDateField(searchListItems);
            this._loomRecentItems = searchListItems;
        }
        return this.filterListItemFields(searchListItems);
    }
    /**
   * Merge list of recent items and search items, and dedupes
   */ mergeResults(itemsA, itemsB) {
        // Dedupe the items based on the URL
        return (0, $4CPyF.filterUniqueItems)([
            ...itemsA,
            ...itemsB
        ], (itemA, itemB)=>itemA.url === itemB.url);
    }
    applyPluginFilter(items) {
        return items.filter(({ objectId: objectId })=>this._pluginItemFilter?.(objectId) ?? true).filter(({ objectId: objectId, url: url })=>this._pluginDataFilter?.({
                id: objectId,
                url: url
            }) ?? true);
    }
    /**
   * Given link picker state yields updates to the list of link picker results
   * The plugin is considered to be in a loading state until the generator returns a final value
   * The plugin can yield intermediate lists of results to present the user with initial results
   * while loading additional results to update the list with.
   */ async *resolve(state) {
        if (this.activityClient && state.query.length === 0) return {
            data: this.applyPluginFilter(await this.getRecentItems())
        };
        // Filter recents based on current state
        const filteredRecentItems = this.applyPluginFilter(await this.searchRecentItems(state));
        // If we have enough results, or there's no search provider to fetch more, return what we have
        if (filteredRecentItems.length >= $072a50f740811d00$export$452f1062ecf44be7 || !this.searchProvider) return {
            data: filteredRecentItems
        };
        if (filteredRecentItems.length) // Update with what we have while we search for more
        yield {
            data: filteredRecentItems
        };
        // Get more results and return them merged with recents
        const searchResults = this.applyPluginFilter(await this.quickSearch(state));
        return {
            data: this.mergeResults(filteredRecentItems, searchResults)
        };
    }
    emptyStateNoResults() {
        if ((0, $dh538.fg)('link-picker-atl-plugin-empty-state')) {
            if (!this.activityClient) return null; // recent activity isn't supported, so leave this as blank
            if (!this.products || this.products.length !== 1) // don't support multi-product, as message gets too confusing
            return null;
            return (0, $7OCSv.renderEmptyStateNoResults)(this.products[0], this.action, this.cloudId, this.isMultisiteSearch);
        }
        return null;
    }
    get tabKey() {
        return this._tabKey;
    }
    get tabTitle() {
        return this._tabTitle;
    }
    get action() {
        return this._action;
    }
    constructor(config){
        this._tabKey = void 0;
        this._tabTitle = void 0;
        this.products = void 0;
        this.debouncedSearch = void 0;
        this.searchProvider = void 0;
        this.activityClient = void 0;
        this.recentItems = void 0;
        this.analyticsIdentifier = 'link-picker-quick-search';
        this.useConfluenceTypeInAri = true;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.isMultisiteSearch = void 0;
        this.allowMultiSiteRecents = void 0;
        this._action = void 0;
        this._scope = void 0;
        this._loomRecentItems = void 0;
        this._pluginItemFilter = void 0;
        this._pluginDataFilter = void 0;
        const { tabConfig: tabConfig, activityClientEndpoint: activityClientEndpoint, disableActivityClient: disableActivityClient = false, searchProvider: searchProvider, cloudId: cloudId, cloudIds: cloudIds, scope: scope, products: products, aggregatorUrl: aggregatorUrl, action: action, itemFilter: itemFilter, dataFilter: dataFilter, allowMultiSiteRecents: allowMultiSiteRecents } = config ?? {};
        const { tabKey: tabKey, tabTitle: tabTitle } = tabConfig ?? {};
        this._tabKey = tabKey || 'Atlassian';
        this._tabTitle = tabTitle || 'Atlassian';
        this.products = products;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.isMultisiteSearch = (this.cloudIds?.length ?? 0) > 0;
        this.allowMultiSiteRecents = this.isMultisiteSearch && allowMultiSiteRecents;
        this._action = action;
        this._scope = scope;
        this._pluginItemFilter = itemFilter;
        this._pluginDataFilter = dataFilter;
        this.searchProvider = searchProvider || this.createSearchProvider(scope, aggregatorUrl, this.analyticsIdentifier, this.useConfluenceTypeInAri);
        if (!disableActivityClient) this.activityClient = (0, $6hu6G.createActivityClient)('v3', 'link_picker_atlassian_plugin', undefined, activityClientEndpoint);
        this.debouncedSearch = (0, $aQaGv.promiseDebounce)(async (query)=>{
            if (!this.searchProvider) return [];
            const searchProvider = await this.searchProvider;
            return searchProvider.quickSearch(query, $072a50f740811d00$export$452f1062ecf44be7);
        }, $072a50f740811d00$var$DEBOUNCE_MS);
    }
}
var $072a50f740811d00$export$2e2bcd8739ae039 = $072a50f740811d00$var$AtlassianLinkPickerPlugin;
module.exports["default"] = $072a50f740811d00$export$2e2bcd8739ae039;

});

parcelRegister("4CPyF", function(module, exports) {
/**
 * Filters array to a set of unique items given a predicate/comparator function
 * @param arr Initial array of items
 * @param comparator Predicate function
 * @returns Array of filtered / unique items
 */ function $b8ef4b094e13b3c4$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
module.exports["filterUniqueItems"] = $b8ef4b094e13b3c4$export$8437fc55448c6e05;

});

parcelRegister("aQaGv", function(module, exports) {
/**
 * Given a callback function returns a promise that resolves to the result of calling the callback function but is
 * debounced (execution is cancelled and promise will remain pending if `promiseDebounce` is re-called within the `time` interval)
 * @param cb Callback which returns result to be resolved
 * @param time Debounce interval
 * @returns Function that returns debounced promise
 */ function $b114f862ee74d165$export$390f1673aa3d5232(cb, time) {
    let timeoutId;
    // Returns a promise that fires the debounce fn and pushes a resolver
    // to have the debounced result resolved
    return (...args)=>{
        timeoutId && clearTimeout(timeoutId);
        return new Promise((resolve, reject)=>{
            timeoutId = setTimeout(()=>{
                cb(...args).then(resolve).catch(reject);
            }, time);
        });
    };
}
module.exports["promiseDebounce"] = $b114f862ee74d165$export$390f1673aa3d5232;

});

parcelRegister("44rik", function(module, exports) {
const $6873537e3409ebab$export$16c4c0987c894b8c = (items, searchTerm)=>{
    if (!searchTerm || !items) return [];
    return items.filter((item)=>{
        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
};
module.exports["filterItems"] = $6873537e3409ebab$export$16c4c0987c894b8c;

});

parcelRegister("k1Kn6", function(module, exports) {

var $7OCSv = parcelRequire("7OCSv");

const $fcdb22c28e10bf47$export$b76efb0c656bea6e = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp, iconUrl: iconUrl, subtype: subtype })=>({
        objectId: objectId,
        name: title,
        container: container,
        url: url,
        ...// Use the icon url from the quick search result if it exists but still resolve the altText,
        // which return defaultAlt if no icon is found. Otherwise find an icon by looking up the content type
        iconUrl ? {
            icon: iconUrl,
            iconAlt: (0, $7OCSv.getIconFromContentType)(contentType, subtype).iconAlt
        } : (0, $7OCSv.getIconFromContentType)(contentType, subtype),
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        prefetch: false,
        meta: {
            source: 'xp-search'
        }
    });
module.exports["mapSearchProviderResultToLinkSearchItemData"] = $fcdb22c28e10bf47$export$b76efb0c656bea6e;

});

parcelRegister("7OCSv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $duwSm = parcelRequire("duwSm");


var $lAFHW = parcelRequire("lAFHW");





var $6iY4P = parcelRequire("6iY4P");


var $l5jcq = parcelRequire("l5jcq");


var $57Wda = parcelRequire("57Wda");


var $kWiYc = parcelRequire("kWiYc");


var $8hhCV = parcelRequire("8hhCV");


var $66dpz = parcelRequire("66dpz");


var $9J3bP = parcelRequire("9J3bP");


var $7G33r = parcelRequire("7G33r");


var $eQfRp = parcelRequire("eQfRp");


var $8d3zB = parcelRequire("8d3zB");


var $dh538 = parcelRequire("dh538");


var $hjLb5 = parcelRequire("hjLb5");


var $d5Nnx = parcelRequire("d5Nnx");

var $0d10d22313e2a678$var$LinkContentType = /*#__PURE__*/ function(LinkContentType) {
    LinkContentType[LinkContentType["jira.issue"] = 0] = "jira.issue";
    LinkContentType[LinkContentType["jira.issue.bug"] = 1] = "jira.issue.bug";
    LinkContentType[LinkContentType["jira.issue.story"] = 2] = "jira.issue.story";
    LinkContentType[LinkContentType["jira.issue.task"] = 3] = "jira.issue.task";
    LinkContentType[LinkContentType["jira.issue.epic"] = 4] = "jira.issue.epic";
    LinkContentType[LinkContentType["jira.dashboard"] = 5] = "jira.dashboard";
    LinkContentType[LinkContentType["jira.board"] = 6] = "jira.board";
    LinkContentType[LinkContentType["jira.project"] = 7] = "jira.project";
    LinkContentType[LinkContentType["jira.filter"] = 8] = "jira.filter";
    LinkContentType[LinkContentType["confluence.page"] = 9] = "confluence.page";
    LinkContentType[LinkContentType["confluence.blogpost"] = 10] = "confluence.blogpost";
    LinkContentType[LinkContentType["confluence.whiteboard"] = 11] = "confluence.whiteboard";
    LinkContentType[LinkContentType["loom.video"] = 12] = "loom.video";
    LinkContentType[LinkContentType["confluence.database"] = 13] = "confluence.database";
    LinkContentType[LinkContentType["confluence.embed"] = 14] = "confluence.embed";
    return LinkContentType;
}($0d10d22313e2a678$var$LinkContentType || {});
const $0d10d22313e2a678$export$74b0c6644317c84d = (product, action, cloudId, isMultisiteSearch)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjLb5.EmptyStateNoResults), {
        product: product,
        action: action,
        cloudId: cloudId,
        isMultisiteSearch: isMultisiteSearch
    });
};
const $0d10d22313e2a678$export$f642707b43bbbafc = (contentType)=>{
    return Boolean(contentType && Object.keys($0d10d22313e2a678$var$LinkContentType).includes(contentType));
};
const $0d10d22313e2a678$export$80e948449ec854a9 = {
    'jira.issue': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconIssueLabel
    },
    'jira.issue.bug': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5jcq.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBugLabel
    },
    'jira.issue.story': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9J3bP.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconStoryLabel
    },
    'jira.issue.task': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconTaskLabel
    },
    'jira.issue.epic': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kWiYc.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconEpicLabel
    },
    'jira.dashboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconDashboardLabel
    },
    'jira.board': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBoardLabel
    },
    'jira.project': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconProjectLabel
    },
    'jira.filter': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconFilterLabel
    },
    'confluence.page': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconPageLabel
    },
    'confluence.blogpost': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iY4P.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBlogLabel
    },
    'confluence.whiteboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eQfRp.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconWhiteboardLabel
    },
    'loom.video': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomIcon), {
                label: alt,
                shouldUseNewLogoDesign: true,
                size: "xxsmall"
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconLoomLabel
    },
    'confluence.database': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57Wda.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconDatabaseLabel
    },
    'confluence.embed': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($duwSm))), {
                color: "var(--ds-icon-accent-blue, #357DE8)",
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconEmbedLabel
    }
};
const $0d10d22313e2a678$export$d71678bb4eba5b81 = (contentType, subtype)=>{
    if (!$0d10d22313e2a678$export$f642707b43bbbafc(contentType)) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).defaultAltText
    };
    if (contentType === 'jira.issue' && (0, $dh538.fg)('confluence-issue-terminology-refresh')) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconIssueLabelIssueTermRefresh
    };
    if (contentType === 'confluence.page' && subtype === 'live') return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66dpz.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconLiveDocLabel
    };
    return $0d10d22313e2a678$export$80e948449ec854a9[contentType];
};
const $0d10d22313e2a678$export$ac1fda7301622804 = (iconUrl)=>{
    let alt = (0, $d5Nnx.messages).defaultAltText;
    // TODO add in extra cases for V3 api
    if (iconUrl.includes('story.svg')) alt = (0, $d5Nnx.messages).story;
    if (iconUrl.includes('epic.svg')) alt = (0, $d5Nnx.messages).epic;
    if (iconUrl.includes('avatarId=10318')) alt = (0, $d5Nnx.messages).task;
    if (iconUrl.includes('avatarId=10303')) alt = (0, $d5Nnx.messages).bug;
    if (iconUrl.includes('avatarId=10518')) alt = (0, $d5Nnx.messages).subTask;
    if (iconUrl.includes('avatarId=10310')) alt = (0, $d5Nnx.messages).improvement;
    return alt;
};
const $0d10d22313e2a678$export$fd251dec3e575ea1 = (iconUrl)=>{
    return {
        icon: iconUrl,
        iconAlt: $0d10d22313e2a678$export$ac1fda7301622804(iconUrl)
    };
};
module.exports["renderEmptyStateNoResults"] = $0d10d22313e2a678$export$74b0c6644317c84d;
module.exports["getIconFromContentType"] = $0d10d22313e2a678$export$d71678bb4eba5b81;
module.exports["getIconFromIconUrl"] = $0d10d22313e2a678$export$fd251dec3e575ea1;

});

parcelRegister("hjLb5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $2Nwuj = parcelRequire("2Nwuj");


var $kiOFr = parcelRequire("kiOFr");


var $kSC7A = parcelRequire("kSC7A");


var $dh538 = parcelRequire("dh538");


var $4CdHI = parcelRequire("4CdHI");

const $6b6b665bcf70315b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noResults: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.heading",
        defaultMessage: "Get started with {productName}."
    },
    noResultsConfluenceDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.confluenceDescription",
        defaultMessage: "Recently viewed pages will appear once you <link>start using Confluence</link>."
    },
    noResultsJiraDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription",
        defaultMessage: "Recently viewed issues will appear once you <link>start using Jira</link>."
    },
    noResultsJiraDescriptionIssueTerminologyRefreshM4: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription-issue-terminology-refresh-m4",
        defaultMessage: "Recently viewed work items will appear once you <link>start using Jira</link>."
    },
    noResultsDefaultDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.defaultDescription",
        defaultMessage: "Recently viewed items will appear once you <link>start using {productName}</link>."
    },
    noResultsConfluenceCreateOption: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.description",
        defaultMessage: "You can also create a new page."
    }
});
const $6b6b665bcf70315b$export$800daf5fbbe96aff = {
    emptyStateNoResults: 'link-picker-empty-state-no-results'
};
const $6b6b665bcf70315b$var$emptyStateWrapperStyles = null;
const $6b6b665bcf70315b$export$e661eeb828fb7b2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { product: product, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { data: data } = (0, $kiOFr.useAvailableSites)();
    const isConfluence = product === "confluence";
    let t1;
    if ($[0] !== cloudId || $[1] !== data || $[2] !== intl || $[3] !== isConfluence || $[4] !== isMultisiteSearch || $[5] !== product) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const productDetails = $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd(product);
            if (!productDetails) {
                t1 = null;
                break bb0;
            }
            const firstMatchingSite = data.find($6b6b665bcf70315b$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
            if (firstMatchingSite) {
                let baseUrl = firstMatchingSite.url;
                if (isConfluence) {
                    baseUrl = baseUrl + "/wiki";
                    baseUrl;
                }
                const intlDescription = intl.formatMessage(productDetails.description, {
                    productName: productDetails.productName,
                    link: (str)=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                            href: baseUrl
                        }, str)
                });
                let t2;
                if ($[7] !== intl || $[8] !== isConfluence) {
                    t2 = isConfluence ? intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceCreateOption) : "";
                    $[7] = intl;
                    $[8] = isConfluence;
                    $[9] = t2;
                } else t2 = $[9];
                const intlConfCreate = t2;
                let t3;
                if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = (0, $gMc0m.default)([
                        "_otyrmgjw _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]);
                    $[10] = t3;
                } else t3 = $[10];
                let t4;
                if ($[11] !== intlConfCreate || $[12] !== intlDescription) {
                    t4 = /*#__PURE__*/ $42omo.createElement("span", null, intlDescription, " ", intlConfCreate);
                    $[11] = intlConfCreate;
                    $[12] = intlDescription;
                    $[13] = t4;
                } else t4 = $[13];
                const t5 = /*#__PURE__*/ $42omo.createElement((0, $abC4X.default), {
                    testId: $6b6b665bcf70315b$export$800daf5fbbe96aff.emptyStateNoResults,
                    header: intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResults, {
                        productName: productDetails.productName
                    }),
                    description: t4,
                    renderImage: $6b6b665bcf70315b$var$_temp
                });
                let t6;
                if ($[14] !== t3 || $[15] !== t5) {
                    t6 = /*#__PURE__*/ $42omo.createElement("div", {
                        className: t3
                    }, t5);
                    $[14] = t3;
                    $[15] = t5;
                    $[16] = t6;
                } else t6 = $[16];
                t1 = t6;
                break bb0;
            }
        }
        $[0] = cloudId;
        $[1] = data;
        $[2] = intl;
        $[3] = isConfluence;
        $[4] = isMultisiteSearch;
        $[5] = product;
        $[6] = t1;
    } else t1 = $[6];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    return null;
} : ({ product: product, action: action, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { data: data } = (0, $kiOFr.useAvailableSites)();
    const isConfluence = product === 'confluence'; // confluence has some special cases
    const productDetails = $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd(product);
    if (!productDetails) return null; // unsupported product
     // find the first matching site for this product
    const firstMatchingSite = data.find($6b6b665bcf70315b$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
    if (firstMatchingSite) {
        let baseUrl = firstMatchingSite.url; // Confluence is a special case where the baseUrl is the same as Jira's, so we need to add the path
        if (isConfluence) baseUrl += '/wiki';
        const intlDescription = intl.formatMessage(productDetails.description, {
            productName: productDetails.productName,
            link: (str)=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: baseUrl
                }, str)
        }); // Confluence is a special case because it has an optional "create", which we'll list as a call to action
        const intlConfCreate = isConfluence ? intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceCreateOption) : '';
        return /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_otyrmgjw _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $abC4X.default), {
            testId: $6b6b665bcf70315b$export$800daf5fbbe96aff.emptyStateNoResults,
            header: intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResults, {
                productName: productDetails.productName
            }),
            description: /*#__PURE__*/ $42omo.createElement("span", null, intlDescription, " ", intlConfCreate),
            renderImage: ()=>/*#__PURE__*/ $42omo.createElement((0, $4CdHI.EmptyStateNoResultsSVG), null)
        }));
    }
    return null;
};
const $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd = (product)=>{
    switch(product){
        case 'confluence':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
                productName: 'Confluence',
                description: $6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceDescription
            };
        case 'jira':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
                productName: 'Jira',
                description: (0, $dh538.fg)('jira-issue-terminology-update-m4') ? $6b6b665bcf70315b$export$defe85febe8b728c.noResultsJiraDescriptionIssueTerminologyRefreshM4 : $6b6b665bcf70315b$export$defe85febe8b728c.noResultsJiraDescription
            };
        case 'atlas':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).ATLAS,
                productName: 'Atlas',
                description: $6b6b665bcf70315b$export$defe85febe8b728c.noResultsDefaultDescription
            };
        default:
            return undefined;
    }
};
const $6b6b665bcf70315b$export$5e557b52f4095909 = (availableSitesProduct, cloudId, isMultisiteSearch)=>{
    return (site)=>{
        // if the product doesn't match, this site doesn't match
        if (!site.products.includes(availableSitesProduct)) return false;
         // if the cloudId is undefined, this site matches (match everything)
        if (!cloudId) return true;
         // if we're mutlisite, match everything - this is probably a mistake,
        // but I'm not going to fix that here, and sticking to consistency with AtlassianLinkPickerPlugin.getRecentItems
        if (isMultisiteSearch) return true;
         // otherwise the site has to match the cloudId
        return site.cloudId === cloudId;
    };
};
function $6b6b665bcf70315b$var$_temp() {
    return /*#__PURE__*/ $42omo.createElement((0, $4CdHI.EmptyStateNoResultsSVG), null);
}
module.exports["EmptyStateNoResults"] = $6b6b665bcf70315b$export$e661eeb828fb7b2;

});

parcelRegister("4CdHI", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c4f341a96ee4101f$var$noResultsSVGStyles = null;
const $c4f341a96ee4101f$export$88f98178b806da03 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 96 96",
            className: (0, $gMc0m.default)([
                "_1bsb16xz _4t3i16xz _19pkidpf _2hwx1wug _otyrpxbi _18u01wug _1e0c1ule"
            ])
        }, /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#FCA700",
            d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
        }), /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#1868DB",
            d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
        }), /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#101214",
            d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
        }), /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#09326C",
            d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _19pkidpf _2hwx1wug _otyrpxbi _18u01wug _1e0c1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#FCA700",
        d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#1868DB",
        d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#101214",
        d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#09326C",
        d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
    }));
};
module.exports["EmptyStateNoResultsSVG"] = $c4f341a96ee4101f$export$88f98178b806da03;

});

parcelRegister("d5Nnx", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $930927a24c397c44$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel",
        defaultMessage: "Issue"
    },
    hyperlinkIconBugLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBugLabel",
        defaultMessage: "Bug"
    },
    hyperlinkIconStoryLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconStoryLabel",
        defaultMessage: "Story"
    },
    hyperlinkIconTaskLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconTaskLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconEpicLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEpicLabel",
        defaultMessage: "Epic"
    },
    hyperlinkIconDashboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDashboardLabel",
        defaultMessage: "Dashboard"
    },
    hyperlinkIconBoardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBoardLabel",
        defaultMessage: "Board"
    },
    hyperlinkIconProjectLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconProjectLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconPlanLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPlanLabel",
        defaultMessage: "Plan"
    },
    hyperlinkIconFilterLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconFilterLabel",
        defaultMessage: "Filter"
    },
    hyperlinkIconPageLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPageLabel",
        defaultMessage: "Page"
    },
    hyperlinkIconBlogLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBlogLabel",
        defaultMessage: "Blog"
    },
    hyperlinkIconWhiteboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconWhiteboardLabel",
        defaultMessage: "Whiteboard"
    },
    hyperlinkIconDatabaseLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDatabaseLabel",
        defaultMessage: "Database"
    },
    hyperlinkIconEmbedLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEmbedLabel",
        defaultMessage: "Smart Link"
    },
    hyperlinkIconLoomLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLoomLabel",
        defaultMessage: "Loom"
    },
    hyperlinkIconLiveDocLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLiveDocLabel",
        defaultMessage: "Live Doc"
    },
    story: {
        id: "fabric.linkPicker.story",
        defaultMessage: "Story"
    },
    epic: {
        id: "fabric.linkPicker.epic",
        defaultMessage: "Epic"
    },
    task: {
        id: "fabric.linkPicker.task",
        defaultMessage: "Task"
    },
    bug: {
        id: "fabric.linkPicker.bug",
        defaultMessage: "Bug"
    },
    subTask: {
        id: "fabric.linkPicker.subTask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "fabric.linkPicker.improvement",
        defaultMessage: "Improvement"
    },
    defaultAltText: {
        id: "fabric.linkPicker.defaultAltText",
        defaultMessage: "List item"
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel-issue-term-refresh",
        defaultMessage: "Work item"
    }
});
module.exports["messages"] = $930927a24c397c44$export$defe85febe8b728c;

});

parcelRegister("4LCen", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");


var $3paC4 = parcelRequire("3paC4");


var $7dyLS = parcelRequire("7dyLS");

const $2fe1ecad5a015726$var$ANALYTICS_IDENTIFIER = 'link-picker';
const $2fe1ecad5a015726$var$JIRA_DASHBOARD_URL_PATTERN = new RegExp(/(.*)\/issues\/\?dashboard=(\d+)$/);
class $2fe1ecad5a015726$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            const result = {
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                }) : item.baseUrl + item.url
            };
            if (item.subtype) result.subtype = item.subtype;
            return result;
        });
    }
    getIconUrlFromAvatar(avatar) {
        if ('urls' in avatar) return avatar.urls['16x16'];
        else return avatar.url;
    }
    jiraResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            // The `item.url` here for Jira content is _usually_ absolute url, except for dashboard where the url is wrong
            // It respond with https://site/issues/?dashboard={dashboardId}, but the url needs to be
            // https://site/jira/dashboards/{dashboardId}
            const dashboardMatch = $2fe1ecad5a015726$var$JIRA_DASHBOARD_URL_PATTERN.exec(item.url);
            const url = dashboardMatch ? `${dashboardMatch[1]}/jira/dashboards/${dashboardMatch[2]}` : item.url;
            return {
                title: item.name,
                url: url,
                container: 'container' in item.attributes && item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], 'issueTypeName' in item.attributes ? item.attributes.issueTypeName : undefined),
                updatedTimestamp: 'updated' in item.attributes ? item.attributes.updated : undefined,
                iconUrl: 'avatar' in item.attributes && item.attributes.avatar ? this.getIconUrlFromAvatar(item.attributes.avatar) : undefined,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: item.attributes['@type'],
                    resourceId: item.id
                }) : url
            };
        });
    }
    townsquareProjectResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareProject'),
                objectId: url
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    townsquareGoalResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { id: id, title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareGoal'),
                objectId: id
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    LoomResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                url: item.url,
                container: item.workspaceName,
                contentType: this.mapToContentType('loom'),
                objectId: item.url,
                updatedTimestamp: item.activityDate || item.createdAt
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    case 'Epic':
                        return 'jira.issue.epic';
                    default:
                        return 'jira.issue';
                }
            case 'project':
                return 'jira.project';
            case 'board':
                return 'jira.board';
            case 'filter':
                return 'jira.filter';
            case 'dashboard':
                return 'jira.dashboard';
            case 'townsquareProject':
                return 'townsquare.project';
            case 'townsquareGoal':
                return 'townsquare.goal';
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            case 'whiteboard':
                return 'confluence.whiteboard';
            case 'database':
                return 'confluence.database';
            case 'embed':
                return 'confluence.embed';
            case 'loom':
                return 'loom.video';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit,
            sites: this.cloudIds
        });
        if (this.scope === (0, $7dyLS.Scope).ConfluencePageBlog || this.scope === (0, $7dyLS.Scope).ConfluencePageBlogWhiteboard || this.scope === (0, $7dyLS.Scope).ConfluenceContentType) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.confluencePageBlogResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).JiraIssue || this.scope === (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.jiraResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).TownsquareProject) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareProjectResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).TownsquareGoal) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareGoalResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).Loom) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.LoomResponseTransformer(scopeResult);
        } else throw new Error(`Unsupported scope - ${this.scope}`);
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2fe1ecad5a015726$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false, cloudIds = []){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).ConfluencePageBlogWhiteboard:
            case (0, $7dyLS.Scope).ConfluenceContentType:
            case (0, $7dyLS.Scope).JiraIssue:
            case (0, $7dyLS.Scope).JiraDashboard:
            case (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter:
            case (0, $7dyLS.Scope).TownsquareProject:
            case (0, $7dyLS.Scope).TownsquareGoal:
            case (0, $7dyLS.Scope).Loom:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}
module.exports["default"] = $2fe1ecad5a015726$export$2e2bcd8739ae039;

});

parcelRegister("1MqUK", function(module, exports) {

var $7OCSv = parcelRequire("7OCSv");

const $13b92bff3b95cf64$export$d82137ca931458ca = ({ object: object, containers: containers, timestamp: timestamp })=>{
    let iconUrl = object.icon?.value || '';
    if (object.icon?.type === 'EMOJI') iconUrl = object.icon.fallback || '';
    const iconData = object.product === 'confluence' ? (0, $7OCSv.getIconFromContentType)(object.product + '.' + object.type.toLowerCase(), object.subtype?.toLowerCase()) : (0, $7OCSv.getIconFromIconUrl)(iconUrl);
    return {
        objectId: object.id,
        name: object.name || '',
        container: $13b92bff3b95cf64$var$getContainerName(containers),
        url: object.url,
        ...iconData,
        lastViewedDate: timestamp ? new Date(timestamp) : undefined,
        prefetch: true,
        meta: {
            source: 'recent-work'
        }
    };
};
const $13b92bff3b95cf64$var$getContainerName = (containers)=>{
    for(let i = containers.length - 1; i >= 0; --i){
        const containerName = containers[i].name;
        if (containerName) return containerName;
    }
    return '';
};
/** No results returned for townsquare (Atlas) if `platform` is used in filter
 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
 */ /**
 * Generate the ARI for particular product to send to the recent items API.
 */ function $13b92bff3b95cf64$var$generateProductSpecificAri(product, cloudId) {
    if (product === 'townsquare') /** No results returned for townsquare (Atlas) if `platform` is used in filter
     * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
     */ return `ari:cloud:townsquare::site/${cloudId}`;
    return `ari:cloud:platform::site/${cloudId}`;
}
function $13b92bff3b95cf64$export$4b7ffcf66d37c47b(products, cloudId) {
    const defaultAri = `ari:cloud:platform::site/${cloudId}`;
    if (products === undefined) return [
        defaultAri
    ];
    const allAris = products.map((product)=>$13b92bff3b95cf64$var$generateProductSpecificAri(product, cloudId));
    // Deduplicate
    return allAris.filter((value, index)=>allAris.indexOf(value) === index);
}
module.exports["mapActivityClientResultToLinkSearchItemData"] = $13b92bff3b95cf64$export$d82137ca931458ca;
module.exports["getArisForProducts"] = $13b92bff3b95cf64$export$4b7ffcf66d37c47b;

});

parcelRegister("icARO", function(module, exports) {
/**
 * Possible values for the current product. This is the order that tabs will appear in - though the first tab will always be the current product.
 * This is currently typed in LinkPickerPluginsConfiguration as `string` so this is used for checking tab order.
 * `atlas` is used as it's a public API.
 * This is also documented in the docstring for `product` in LinkPickerPluginsConfiguration.
 */ const $b5f4a14afbf914da$export$15d6fc53154f51b3 = [
    'loom',
    'jira',
    'confluence',
    'atlas',
    'townsquare'
];
module.exports["supportedCurrentProducts"] = $b5f4a14afbf914da$export$15d6fc53154f51b3;

});

parcelRegister("3FTlm", function(module, exports) {

var $icARO = parcelRequire("icARO");

const $c011f3c2795ed007$var$suportedCurrentProductMap = {
    'jira-core.ondemand': 'jira',
    'jira-incident-manager.ondemand': 'jira',
    'jira-product-discovery': 'jira',
    'jira-servicedesk.ondemand': 'jira',
    'jira-software.ondemand': 'jira',
    'confluence.ondemand': 'confluence',
    townsquare: 'atlas',
    loom: 'loom'
};
function $c011f3c2795ed007$export$40cf7a2a01d13d9d(str) {
    const strings = (0, $icARO.supportedCurrentProducts);
    return strings.includes(str);
}
function $c011f3c2795ed007$export$7e250790d0036a52(product) {
    // Product may not be in supportedProducts array, that's what this is checking
    if (!(product in $c011f3c2795ed007$var$suportedCurrentProductMap)) return undefined;
    return $c011f3c2795ed007$var$suportedCurrentProductMap[product];
}
module.exports["isSupportedCurrentProduct"] = $c011f3c2795ed007$export$40cf7a2a01d13d9d;
module.exports["lookupCurrentProductByProduct"] = $c011f3c2795ed007$export$7e250790d0036a52;

});

parcelRegister("d4Mwr", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kiOFr = parcelRequire("kiOFr");

const $30f10d0a027e62a0$export$5afbfe6edea8e998 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (cloudId)=>{
    const $ = (0, $frIzR.c)(9);
    const { data: data, loading: isLoading } = (0, $kiOFr.useAvailableSites)();
    let t0;
    bb0: {
        if (!data.length) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = [];
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        if (cloudId) {
            let t1;
            if ($[1] !== cloudId || $[2] !== data) {
                t1 = data.find((site)=>site.cloudId === cloudId)?.products ?? [];
                $[1] = cloudId;
                $[2] = data;
                $[3] = t1;
            } else t1 = $[3];
            t0 = t1;
            break bb0;
        }
        let t1;
        if ($[4] !== data) {
            t1 = Array.from(data.reduce($30f10d0a027e62a0$var$_temp, new Set()));
            $[4] = data;
            $[5] = t1;
        } else t1 = $[5];
        t0 = t1;
    }
    let t1;
    if ($[6] !== isLoading || $[7] !== t0) {
        t1 = {
            availableProducts: t0,
            isLoading: isLoading
        };
        $[6] = isLoading;
        $[7] = t0;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : (cloudId)=>{
    const { data: data, loading: isLoading } = (0, $kiOFr.useAvailableSites)();
    return {
        availableProducts: (0, $42omo.useMemo)(()=>{
            if (!data.length) return [];
            if (cloudId) return data.find((site)=>site.cloudId === cloudId)?.products ?? [];
            // Get all the products from all sites and deduplicate
            return Array.from(data.reduce((prev, curr)=>{
                return new Set([
                    ...curr.products,
                    ...Array.from(prev)
                ]);
            }, new Set()));
        }, [
            data,
            cloudId
        ]),
        isLoading: isLoading
    };
};
function $30f10d0a027e62a0$var$_temp(prev, curr) {
    return new Set([
        ...curr.products,
        ...Array.from(prev)
    ]);
}
module.exports["useAvailableProducts"] = $30f10d0a027e62a0$export$5afbfe6edea8e998;

});


//# sourceMappingURL=root-component.66ac2123.js.map
